import { render, staticRenderFns } from "./MaxConcentrationExemptionDetails.vue?vue&type=template&id=38907651&"
import script from "./MaxConcentrationExemptionDetails.vue?vue&type=script&lang=js&"
export * from "./MaxConcentrationExemptionDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports